import { render, staticRenderFns } from "./LovForm.vue?vue&type=template&id=522aaefe&"
import script from "./LovForm.vue?vue&type=script&lang=js&"
export * from "./LovForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports